/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable use-encapsulation/prefer-custom-hooks */
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogFooter,
  Button,
  useDisclosure,
} from '@chakra-ui/react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

interface IAlertDialogInfoProps {
  onSubmit: () => void;
  onToggleDialog: (open: boolean) => void;
  shouldOpenDialog: boolean;
}

export const AlertDialogInfo: React.FC<IAlertDialogInfoProps> = ({
  onSubmit,
  onToggleDialog,
  shouldOpenDialog,
}): JSX.Element => {
  const { t } = useTranslation();
  const cancelRef = useRef<HTMLButtonElement>(null);
  const { onClose } = useDisclosure();

  return (
    <AlertDialog isOpen={shouldOpenDialog} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent bgColor="white" borderRadius={0} color="brand.black" p={4}>
          <AlertDialogBody mb={10}>{t('FORM.NO_INSURANCE_ALERT.TEXT')}</AlertDialogBody>
          <AlertDialogFooter>
            <Button colorScheme="red" variant="link" onClick={onSubmit}>
              {t('FORM.NO_INSURANCE_ALERT.PROCEED')}
            </Button>
            <Button ml={3} variant="mbePrimary" onClick={(): void => onToggleDialog(false)}>
              {t('FORM.NO_INSURANCE_ALERT.GO_BACK')}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
